import { render, staticRenderFns } from "./gl.vue?vue&type=template&id=c74a7124&scoped=true&"
import script from "./gl.vue?vue&type=script&lang=js&"
export * from "./gl.vue?vue&type=script&lang=js&"
import style0 from "./gl.vue?vue&type=style&index=0&id=c74a7124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74a7124",
  null
  
)

export default component.exports